import toast from "react-hot-toast";
import { UNITS, UnitType } from "../models/warehouseRawMaterial.model";

const UNIT_TO_BASE_FACTOR: Record<string, Record<string, number>> = {
  weight: { mg: 0.001, g: 1, kg: 1000 },
  liquid: { ml: 1, l: 1000 },
  length: { mm: 1, cm: 10, m: 1000 },
  piece: { piece: 1 },
};

export const convertStockQuantity = (
  quantity: number,
  fromUnit: string,
  toUnit: string,
  unitType: string,
): number | null => {
  const normalizedFromUnit = fromUnit.toLowerCase();
  const normalizedToUnit = toUnit.toLowerCase();
  if (normalizedFromUnit === normalizedToUnit) return quantity;

  const conversionFactors = UNIT_TO_BASE_FACTOR[unitType];
  const fromFactor = conversionFactors?.[normalizedFromUnit];
  const toFactor = conversionFactors?.[normalizedToUnit];
  if (!fromFactor || !toFactor) return null;

  return (quantity * fromFactor) / toFactor;
};

export const getDefaultUnitForType = (unitType: string): UnitType => {
  switch (unitType) {
    case "weight":
      return "kg";
    case "liquid":
      return "l";
    case "length":
      return "m";
    case "piece":
      return "piece";
    default:
      return "piece";
  }
};

export const getUnitsByType = (unitType: string) => {
  switch (unitType) {
    case "weight":
      return UNITS.filter((u) => ["mg", "g", "kg"].includes(u.value));
    case "liquid":
      return UNITS.filter((u) => ["ml", "l"].includes(u.value));
    case "length":
      return UNITS.filter((u) => ["mm", "cm", "m"].includes(u.value));
    case "piece":
    default:
      return UNITS.filter((u) => ["piece"].includes(u.value));
  }
};

export const isValidateSerialNumber = (serial: string): boolean => {
  const isValid = /^\d{10}$/.test(serial);
  if (!isValid) {
    toast.error("Serial must be 10 numeric digits");
  }
  return isValid;
};
